import React, { useEffect, useState } from "react";
import { channelVideos } from "../lib/api";
import { fmtTime } from "./tv/ChannelVideos";

const Fact = ({ v }) => {
  const [open, setOpen] = useState(false);
  return (
    <button onClick={() => setOpen((o) => !o)} className="w-full text-left rounded-2xl bg-white/5 border border-cyan-300/15 p-4 space-y-2" data-testid={`remote-fact-${v.video_id}`}>
      <p className="text-xs text-cyan-300/60">{v.channel} · {fmtTime(v.scraped_at)}</p>
      <p className="text-base font-bold leading-snug">{v.title}</p>
      <p className="text-sm text-violet-300 font-bold">{v.topic}</p>
      <ul className="list-disc pl-5 text-sm text-cyan-100/80 space-y-1">{(v.facts || []).slice(0, open ? 12 : 3).map((f, i) => <li key={i}>{f}</li>)}</ul>
      {open && <div className="pt-2 border-t border-cyan-300/10 text-sm text-cyan-50/90 space-y-1" data-testid={`remote-fact-summary-${v.video_id}`}>{(v.summary || []).map((s, i) => <p key={i}>• {s}</p>)}</div>}
      <p className="text-[11px] text-cyan-300/50">{open ? "Tap to close" : "Tap for the summary"}</p>
    </button>
  );
};

export const RemoteFacts = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { channelVideos({ limit: 20, full: false }).then((d) => setItems(d.items)).catch(() => setItems([])); }, []);
  return (
    <section className="space-y-3" data-testid="remote-facts">
      <p className="text-xs tracking-[0.3em] text-cyan-300/60 font-bold">FACTS · LATEST CHANNEL VIDEOS</p>
      {items === null ? <p className="text-sm text-cyan-100/50">Loading…</p> : items.length === 0
        ? <p className="text-sm text-cyan-100/50" data-testid="remote-facts-empty">No channel videos yet.</p>
        : items.map((v) => <Fact key={v.video_id} v={v} />)}
    </section>
  );
};
